import { Store } from 'bernie-plugin-mobx';
import { CarDropOffSearch, CarSearchV3 } from 'common/__generated__/api';
import { observable } from 'mobx';

export class MapStore extends Store {
  @observable
  public showSheet: boolean = false;

  @observable
  public selectedMarker:
    | CarDropOffSearch.CarMapDropOffLocationCardInlineFragment
    | CarSearchV3.CarMapPickupLocationCardInlineFragment;

  @observable
  public selectedLocation: string = null;

  @observable
  public markers: CarSearchV3.Markers | CarDropOffSearch.Markers;

  public cleanSelectedLocation = () => {
    this.selectedMarker = null;
    this.showSheet = false;
    this.selectedLocation = null;
  };

  public hydrate(): void {
    return;
  }
}
